const apiBase = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/$/, '')
const tokenKey = 'matrix-content-os:api-token:v1'

export class ApiError extends Error {
  constructor(message, status, code) {
    super(message)
    this.status = status
    this.code = code
  }
}

async function request(path, options = {}) {
  const headers = new Headers(options.headers || {})
  const token = window.localStorage.getItem(tokenKey)
  if (token) headers.set('Authorization', `Bearer ${token}`)
  if (options.body && !(options.body instanceof FormData) && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')
  const response = await fetch(`${apiBase}${path}`, { ...options, headers })
  const contentType = response.headers.get('content-type') || ''
  const payload = contentType.includes('application/json') ? await response.json() : null
  if (!response.ok) throw new ApiError(payload?.message || '服务器请求失败', response.status, payload?.error || 'REQUEST_FAILED')
  return payload
}

export const apiClient = {
  hasToken: () => Boolean(window.localStorage.getItem(tokenKey)),
  clearToken: () => window.localStorage.removeItem(tokenKey),
  async login(email, password) {
    const result = await request('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) })
    window.localStorage.setItem(tokenKey, result.token)
    return result
  },
  me: () => request('/auth/me'),
  health: () => request('/health'),
  listProjects: () => request('/projects'),
  getProjectState: projectId => request(`/projects/${encodeURIComponent(projectId)}/state`),
  createProject: project => request('/projects', { method: 'POST', body: JSON.stringify(project) }),
  updateProject: project => request(`/projects/${encodeURIComponent(project.id)}`, { method: 'PATCH', body: JSON.stringify(project) }),
  saveMember: member => request(`/members/${encodeURIComponent(member.id)}`, { method: 'PUT', body: JSON.stringify(member) }),
  deleteMember: memberId => request(`/members/${encodeURIComponent(memberId)}`, { method: 'DELETE' }),
  saveEntity: (projectId, collection, entity) => request(`/projects/${encodeURIComponent(projectId)}/entities/${encodeURIComponent(collection)}/${encodeURIComponent(entity.id)}`, { method: 'PUT', body: JSON.stringify(entity) }),
  deleteEntity: (projectId, collection, entityId) => request(`/projects/${encodeURIComponent(projectId)}/entities/${encodeURIComponent(collection)}/${encodeURIComponent(entityId)}`, { method: 'DELETE' }),
  replaceEntities: (projectId, collection, items) => request(`/projects/${encodeURIComponent(projectId)}/entities/${encodeURIComponent(collection)}`, { method: 'PUT', body: JSON.stringify({ items }) }),
  captureReference: (projectId, url, tags = []) => request(`/projects/${encodeURIComponent(projectId)}/references/capture`, { method: 'POST', body: JSON.stringify({ url, tags }) }),
  getWecomStatus: projectId => request(`/projects/${encodeURIComponent(projectId)}/integrations/wecom/status`),
  testWecomDevice: (projectId, deviceId) => request(`/projects/${encodeURIComponent(projectId)}/integrations/wecom/test`, { method: 'POST', body: JSON.stringify({ deviceId }) }),
  sendWecomDeviceTasks: (projectId, deviceId, date) => request(`/projects/${encodeURIComponent(projectId)}/integrations/wecom/device-tasks/send`, { method: 'POST', body: JSON.stringify({ deviceId, ...(date ? { date } : {}) }) }),
  importLocalState: state => request('/migrations/local-state', { method: 'POST', body: JSON.stringify({ state }) }),
  uploadAssetFiles(projectId, assetId, files) {
    const body = new FormData()
    files.forEach(file => body.append('files', file, file.name))
    return request(`/projects/${encodeURIComponent(projectId)}/assets/${encodeURIComponent(assetId)}/files`, { method: 'POST', body })
  },
}
